import React from "react";
import { Link } from "react-router-dom";
import StoryReader from "../components/story/StoryReader";

export default function StoryPage() {
  return (
    <div>
      <StoryReader />
    </div>
  );
}

